<template>
  <div>
    <div style="height:94%;padding: 0 5% 50px 5%;">
        <iframe
         style="border:none;width:100%;height:100%;"
         v-bind:src="reportUrl">
        </iframe>
    </div>
  </div>
</template>

<script>
import { myInfo, getKvList } from '@/utils/request'

export default {
  name: 'CAPACITY_KPI',
  data () {
    return {
        reportUrl: '',
        groupName: []
    }
  },
  created () {
  },
  mounted () {
    this.GroupComponent()
  },
  methods: {
    GroupComponent () {
        myInfo().then(response => {
            getKvList('Shop').then(res => {
                var Ids = ''
                for (var item of res.data) {
                    Ids += item.id + "','"
                }
                Ids = Ids.slice(0, Ids.length - 3)
                // var loginUser = response.data.user.account
                // var UrlComponent = 'jt/' + '效率KPI指标'
                // UrlComponent = encodeURIComponent(UrlComponent)
                // this.reportUrl = 'https://www.cdseku.com/webroot/decision/view/report?viewlet=' + UrlComponent + '.cpt&op=view&fine_username=' + loginUser + '&fine_password=kpi123456&shop_code=' +
                // Ids + '&root_db=' + this.ReportConfig.VUE_ROOT_DB + '&group_db=' + this.ReportConfig.VUE_GROUP_DB + '&shop_db=' + this.ReportConfig.VUE_SHOP_DB
                // console.log(this.reportUrl)
                // this.reportUrl = 'https://fr.miaomaicar.com/webroot/decision/view/report?viewlet=PPG/%E6%95%88%E7%8E%87KPI%E6%8C%87%E6%A0%87.cpt&op=view&shop_code=1%27,%275%27,%276%27,%277&root_db=sheet_spray_root&group_db=cqwyjt_group&shop_db=cqwyjt_caqy_shop'
                this.reportUrl = 'https://fr.miaomaicar.com/webroot/decision/view/report?viewlet=PPG/效率KPI指标.cpt&op=view&shop_code=' +
                Ids + '&root_db=' + this.ReportConfig.VUE_ROOT_DB + '&group_db=' + this.ReportConfig.VUE_GROUP_DB + '&shop_db=' + this.ReportConfig.VUE_SHOP_DB
                console.log(this.reportUrl)
            })
        })
    }
  },
  computed: {
  }
}
</script>
